import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const billingShiftDifferentialModStyles = makeStyles<{ isModEdit?: boolean }>()(
  (theme: Theme, { isModEdit }) => ({
    expandedGrid: {
      fontSize: '14px',
      '& .MuiDataGrid-main': {
        minHeight: '60px',
      },
    },
    isErrorCell: {
      border: '1px solid !important',
      borderRadius: '4px',
      borderColor: 'red',
      color: 'red',
    },
    switchLightBlue: {
      '& .MuiSwitch-switchBase': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#A8CAED',
      },
      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        color: isModEdit ? '#A8CAED' : '#E6EEF9',
      },
    },
    descriptionlb: {
      fontSize: '12px !important',
      fontWeight: 'bold',
      marginRight: '24px',
    },
    descriptionValue: {
      marginRight: '70px',
    },
    quantityValue: {
      '& .MuiDataGrid-cell': {
        paddingLeft: '24px',
      },
    },
    gridRow: {
      marginBottom: '24px',
    },
    radioLabel: {
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: '#333333',
      },
    },
    templateLb: {
      marginTop: '11px',
      marginRight: '10px',
      color: isModEdit ? '#333333 !important' : '#888888 !important',
    },
  }),
);
